import Tooltip from 'rc-tooltip';

import { CoordsError, DeviceBlockIncognito, KeyQrActive, KeyQrLive } from '~modules/settings/model';
import { CheckBox, InputText, Preloader, Svg } from '~shared/ui';

import { useSettings } from './use-settings.ts';

export function SettingsPage() {
	const { pending, settings, changeValue, save, saving } = useSettings();

	const handleChangeQrActive = (val: string) => {
		changeValue(KeyQrActive, val);
	};

	const handleChangeQrLive = (val: string) => {
		changeValue(KeyQrLive, val);
	};

	const handleChangeCoordsError = (val: string) => {
		const value = val === '' || isNaN(Number(val)) ? '0' : val;
		changeValue(CoordsError, value);
	};

	const handleChangeBlockIncognito = (checked: boolean) => {
		changeValue(DeviceBlockIncognito, checked ? '1' : '0');
	};

	return (
		<div className="settings-page">
			<h4>Настройки QR</h4>
			{pending ? (
				<Preloader />
			) : (
				<div className="row">
					<div className="col col--45">
						<InputText
							value={settings[KeyQrActive]?.value ?? ''}
							placeholder={settings[KeyQrActive]?.title ?? ''}
							onChange={handleChangeQrActive}
						/>
					</div>
					<div className="col col--45">
						<InputText
							value={settings[KeyQrLive]?.value ?? ''}
							placeholder={settings[KeyQrLive]?.title}
							onChange={handleChangeQrLive}
						/>
					</div>
					<div className="col col--45">
						<InputText
							value={settings[CoordsError]?.value ?? ''}
							placeholder={settings[CoordsError]?.title}
							onChange={handleChangeCoordsError}
						/>
					</div>
					<div className="col col--45">
						<CheckBox
							label={settings[DeviceBlockIncognito]?.title ?? 'Запрет отметок из приватного режима'}
							checked={settings[DeviceBlockIncognito]?.value === '1'}
							onChange={handleChangeBlockIncognito}
						/>
					</div>
					{saving ? (
						<Preloader />
					) : (
						<Tooltip placement="top" overlay="Сохранить">
							<button className="btn btn--secondary" onClick={save}>
								<Svg name="save" />
							</button>
						</Tooltip>
					)}
				</div>
			)}
		</div>
	);
}
